export default "__VITE_ASSET__bfe82b12__"